/**
 * A/B Test: Ultra Family Pack (6) Bundle Visibility
 *
 * Managed via body attribute (set by IntelliGems — no theme settings):
 *   document.body.setAttribute('data-hide-family-pack', 'true');  // Test A — hide pack of 6
 *   document.body.setAttribute('data-hide-family-pack', 'false'); // Test B — show pack of 6
 */
(function () {
  'use strict';

  if (window.__hideFamilyPackABTestInit) return;
  window.__hideFamilyPackABTestInit = true;

  var BODY_ATTR = 'data-hide-family-pack';
  var HIDE_LABELS = ['Ultra Family Pack (6)'];
  var HIDDEN_ATTR = 'data-hide-family-pack-ab-hidden';
  var timer = null;
  var busy = false;

  function shouldHideBundle() {
    var body = document.body;
    if (!body) return false;

    return body.getAttribute(BODY_ATTR) === 'true';
  }

  function normalize(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function matchesHideLabel(text) {
    var normalized = normalize(text);
    var i;

    for (i = 0; i < HIDE_LABELS.length; i++) {
      if (normalized.indexOf(HIDE_LABELS[i]) > -1) return true;
    }

    return false;
  }

  function getBarLabel(bar) {
    var title =
      bar.querySelector('.kaching-bundles__bar-title') ||
      bar.querySelector('[class*="bar-title"]') ||
      bar.querySelector('[class*="bar-name"]') ||
      bar.querySelector('label') ||
      null;

    return normalize(title ? title.textContent : bar.textContent);
  }

  function isBarSelected(bar) {
    if (!bar) return false;

    if (
      bar.classList.contains('kaching-bundles__bar--selected') ||
      bar.getAttribute('aria-checked') === 'true'
    ) {
      return true;
    }

    var radio = bar.querySelector('input[type="radio"]');
    return !!(radio && radio.checked);
  }

  function selectFirstVisibleBar(container) {
    var bars = container.querySelectorAll('.kaching-bundles__bar, [class*="kaching-bundles__bar"]');
    var i;
    var bar;
    var radio;

    for (i = 0; i < bars.length; i++) {
      bar = bars[i];
      if (bar.getAttribute(HIDDEN_ATTR)) continue;
      if (bar.style.display === 'none') continue;
      if (bar.closest('[' + HIDDEN_ATTR + ']')) continue;

      radio = bar.querySelector('input[type="radio"]');
      if (!radio || radio.disabled) continue;

      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      bar.click();
      return;
    }
  }

  function hideBar(bar) {
    if (!bar || bar.getAttribute(HIDDEN_ATTR)) return;

    var wasSelected = isBarSelected(bar);
    var container =
      bar.closest('kaching-bundles-block') ||
      bar.closest('kaching-bundle') ||
      bar.closest('[class*="kaching-bundles"]') ||
      bar.parentElement;

    bar.setAttribute(HIDDEN_ATTR, 'true');
    bar.style.display = 'none';
    bar.setAttribute('aria-hidden', 'true');

    var radio = bar.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = false;
      radio.disabled = true;
      radio.tabIndex = -1;
    }

    if (wasSelected && container) {
      selectFirstVisibleBar(container);
    }
  }

  function showBar(bar) {
    if (!bar || !bar.getAttribute(HIDDEN_ATTR)) return;

    bar.removeAttribute(HIDDEN_ATTR);
    bar.style.display = '';
    bar.removeAttribute('aria-hidden');

    var radio = bar.querySelector('input[type="radio"]');
    if (radio) {
      radio.disabled = false;
      radio.tabIndex = 0;
    }
  }

  function findBundleBars() {
    return document.querySelectorAll('.kaching-bundles__bar');
  }

  function processBundles() {
    if (busy) return;
    busy = true;

    try {
      var hideBundle = shouldHideBundle();
      var bars = findBundleBars();
      var i;
      var bar;
      var label;

      for (i = 0; i < bars.length; i++) {
        bar = bars[i];
        label = getBarLabel(bar);

        if (!matchesHideLabel(label)) continue;

        if (hideBundle) {
          hideBar(bar);
        } else {
          showBar(bar);
        }
      }
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(processBundles, 50);
  }

  function watchBodyAttribute() {
    if (!document.body) return;

    new MutationObserver(function () {
      schedule();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR]
    });
  }

  function init() {
    processBundles();
    watchBodyAttribute();

    if (window.MutationObserver && document.body) {
      new MutationObserver(function () {
        schedule();
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    setTimeout(processBundles, 400);
    setTimeout(processBundles, 1200);
    setTimeout(processBundles, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', schedule);
})();
